module.exports = __webpack_public_path__ + "static/media/11b_hero_mobile.0d79e213.jpg";